import API from "./apiUrls";
import axios from "axios";
import { consumeImportSseResponse } from "../utils/importProgressStream";


const headerOptions = {

    headers: {
        // Removed bogus request header "access-control-allow-origin: http://google.com"
        // (that's a response-only header with a nonsense value; pollutes preflight).
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('token')
    }
}


const apiFunctions = {

    login: (body) => {
        return axios.post(`${API.logIn}`, body, {
            headers: {
                "Cache-Control": "no-cache",
                "Content-Type": "application/json",
                'Access-Control-Allow-Headers': '*',
                "Access-Control-Allow-Origin": "*",
            }
        })
    },
    forgotPassword: (body) => {
        return axios.post(`${API.forgotPassword}`, body)
    },
    logout: () => {
        return axios.get(`${API.logOut}`, headerOptions)
    },
    getTerms: () => {
        return axios.get(`${API.getTerms}`, headerOptions)
    },
    getSubstantAction: () => {
        return axios.get(`${API.getSubstantAction}`, headerOptions)
    },
    updateTerms: (body) => {
        return axios.put(`${API.updateTerms}`, body, headerOptions)
    },
    getPrivacy: () => {
        return axios.get(`${API.getPrivacy}`, headerOptions)
    },
    updatePrivacy: (body) => {
        return axios.put(`${API.updatePrivacy}`, body, headerOptions)
    },
    getLegal: () => {
        return axios.get(`${API.getLegal}`, headerOptions)
    },
    getAdminProfile: () => {
        return axios.get(`${API.getAdminProfile}`, headerOptions)
    },
    getGraphDetails: (body) => {
        return axios.get(`${API.getGraphDetails}/${body}`, headerOptions)
    },
    updateAdminProfile: (body) => {
        return axios.put(`${API.updateAdminProfile}`, body, headerOptions)
    },
    updateDistance: (body) => {
        return axios.put(`${API.updateDistance}`, body, headerOptions)
    },
    changePassword: (body) => {
        return axios.post(`${API.changePassword}`, body, headerOptions)
    },
    getAllUsers: (limit, searchKey, page) => {
        return axios.get(`${API.getAllUsers}?limit=${limit}&name=${searchKey}&page=${page}`, headerOptions)
    },
    getAllSlots: (limit, searchKey, page, dateId) => {
        return axios.get(`${API.getAllSlots}?limit=${limit}&name=${searchKey}&page=${page}&dateId=${dateId}`, headerOptions)
    },
    getAllEventAttend: (limit, searchKey, page, slotId) => {
        return axios.get(`${API.getAllEventAttend}?limit=${limit}&name=${searchKey}&page=${page}&slotId=${slotId}`, headerOptions)
    },
    getAllFeedback: (limit, searchKey, page) => {
        return axios.get(`${API.getAllFeedback}?limit=${limit}&search=${searchKey}&page=${page}`, headerOptions)
    },
    getAllNews: (limit, searchKey, page) => {
        return axios.get(`${API.getAllNews}?limit=${limit}&search=${searchKey}&page=${page}`, headerOptions)
    },
    getAllFaq: (limit, searchKey, page) => {
        return axios.get(`${API.getAllFaq}?limit=${limit}&search=${searchKey}&page=${page}`, headerOptions)
    },
    // NOTE: activeOnly defaults true on API (pickers). Pass false for Tags admin list.
    getAllTag: (limit, searchKey, page, options = {}) => {
        const params = new URLSearchParams({
            limit: String(limit),
            search: searchKey == null ? '' : String(searchKey),
            page: String(page),
        });
        if (options.activeOnly !== undefined) {
            params.set('activeOnly', String(options.activeOnly));
        }
        if (options.isDeleted !== undefined && options.isDeleted !== '') {
            params.set('isDeleted', String(options.isDeleted));
        }
        return axios.get(`${API.getAllTag}?${params.toString()}`, headerOptions)
    },
    getAllCountries: (limit, type, country_code) => {
        return axios.get(`${API.getAllCountries}?limit=${limit}&type=${type}&country_code=${country_code}`, headerOptions)
    },
    getAllSuggestions: (limit, searchKey, page) => {
        return axios.get(`${API.getAllSuggestions}?limit=${limit}&search=${searchKey}&page=${page}`, headerOptions)
    },
    uploadPhoto: (formData) => {
        return axios.post(`${API.uploadPhoto}`, formData, {
            headers: {
                'Content-Type': '',
                'Authorization': localStorage.getItem('token')
            }
        })
    },
    uploadGraphPhoto: (formData) => {
        return axios.post(`${API.uploadGraphPhoto}`, formData, {
            headers: {
                'Content-Type': '',
                'Authorization': localStorage.getItem('token')
            }
        })
    },
    uploadNewsPhoto: (formData) => {
        return axios.post(`${API.uploadNewsPhoto}`, formData, {
            headers: {
                'Content-Type': '',
                'Authorization': localStorage.getItem('token')
            }
        })
    },
    getAllEvents: (limit, searchKey, page, type, eventType = 'all') => {
        return axios.get(`${API.getAllEvents}?limit=${limit}&search=${searchKey}&page=${page}&type=${type}&event_type=${eventType}`, headerOptions)
    },
    getAllEventsDate: (id, limit, searchKey, page) => {
        return axios.get(`${API.getAllEventsDate}?limit=${limit}&search=${searchKey}&page=${page}&id=${id}`, headerOptions)
    },
    createEvent: (body) => {
        return axios.post(`${API.createEvent}`, body, headerOptions)
    },
    createNews: (body) => {
        return axios.post(`${API.createNews}`, body, headerOptions)
    },
    createFaq: (body) => {
        return axios.post(`${API.createFaq}`, body, headerOptions)
    },
    createTag: (body) => {
        return axios.post(`${API.createTag}`, body, headerOptions)
    },
    updateTag: (id, body) => {
        return axios.put(`${API.updateTag}/${id}`, body, headerOptions)
    },
    createSlot: (body) => {
        return axios.post(`${API.createSlot}`, body, headerOptions)
    },
    getUserProfile: (id) => {
        return axios.get(`${API.getUserProfile}/${id}`, headerOptions)
    },
    eventDetail: (id) => {
        return axios.get(`${API.eventDetail}/${id}`, headerOptions)
    },
    importEvents: (body) => {
        return axios.post(`${API.updateEvent}/import`, body, headerOptions)
    },
    importEventsExcel: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return axios.post(`${API.updateEvent}/import/excel`, formData, {
            headers: {
                Authorization: localStorage.getItem('token'),
            },
        });
    },
    importEventsExcelStream: async (file, onProgress) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await fetch(`${API.updateEvent}/import/excel/stream`, {
            method: 'POST',
            headers: {
                Authorization: localStorage.getItem('token'),
            },
            body: formData,
        });
        return consumeImportSseResponse(response, onProgress);
    },
    importEventsStream: async (body, onProgress) => {
        const response = await fetch(`${API.updateEvent}/import/stream`, {
            method: 'POST',
            headers: {
                Authorization: localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return consumeImportSseResponse(response, onProgress);
    },
    getNews: (id) => {
        return axios.get(`${API.getNews}/${id}`, headerOptions)
    },
    getFaq: (id) => {
        return axios.get(`${API.getFaq}/${id}`, headerOptions)
    },
    getFeedback: (id) => {
        return axios.get(`${API.getFeedback}/${id}`, headerOptions)
    },
    getEventsDateDetail: (id) => {
        return axios.get(`${API.getEventsDateDetail}/${id}`, headerOptions)
    },
    addFriends: (body) => {
        return axios.put(`${API.addFriends}`, body, headerOptions)
    },
    updateUser: (id, body) => {
        return axios.put(`${API.updateUserProfile}/${id}`, body, headerOptions)
    },
    updateGraphDetails: (id, body) => {
        return axios.put(`${API.updateGraphDetails}/${id}`, body, headerOptions)
    },
    updateNews: (id, body) => {
        return axios.put(`${API.updateNews}/${id}`, body, headerOptions)
    },
    updateFaq: (id, body) => {
        return axios.put(`${API.updateFaq}/${id}`, body, headerOptions)
    },
    updateEvent: (id, body) => {
        return axios.put(`${API.updateEvent}/${id}`, body, headerOptions)
    },
    updateStatus: (id, body) => {
        return axios.patch(`${API.updateEvent}/${id}`, body, headerOptions)
    },
    updateEventsDate: (body) => {
        return axios.put(`${API.updateEventsDate}`, body, headerOptions)
    },
    updateSlots: (body) => {
        return axios.put(`${API.updateSlots}`, body, headerOptions)
    },
    blockUser: (body) => {
        return axios.put(`${API.blockUser}`, body, headerOptions)
    },
    removeUser: (body) => {
        return axios.put(`${API.removeUser}`, body, headerOptions)
    },
    removeSuggestion: (id) => {
        return axios.delete(`${API.removeSuggestion}/${id}`, headerOptions)
    },
    removeFeedback: (id) => {
        return axios.delete(`${API.removeFeedback}/${id}`, headerOptions)
    },
    removeNews: (id) => {
        return axios.delete(`${API.removeNews}/${id}`, headerOptions)
    },
    removeFaq: (id) => {
        return axios.delete(`${API.removeFaq}/${id}`, headerOptions)
    },
    removeTag: (id) => {
        return axios.delete(`${API.removeTag}/${id}`, headerOptions)
    },
    removeEvent: (body) => {
        return axios.delete(`${API.removeEvent}/${body._id}`, headerOptions)
    },
    deleteSlot: (body) => {
        return axios.delete(`${API.deleteSlot}/${body._id}`, headerOptions)
    },
    deleteDate: (body) => {
        return axios.delete(`${API.deleteDate}/${body.id}`, headerOptions)
    },
    addMoreSchedule: (body) => {
        return axios.post(`${API.addMoreSchedule}`, body, headerOptions)
    },
    getAllRemovedUsers: (limit, searchKey, page) => {
        return axios.get(`${API.getAllRemovedUsers}?limit=${limit}&name=${searchKey}&page=${page}`, headerOptions)
    },
    unFriend: (body) => {
        return axios.put(`${API.unFriend}`, body, headerOptions)
    },
    Groups: (body, limit, searchKey, page) => {
        return axios.get(`${API.Groups}/${body._id}`, headerOptions)
    },
    getAllFriendsAndGroups: (body, limit, searchKey, page) => {
        return axios.get(`${API.getAllFriendsAndGroups}?limit=${limit}&name=${searchKey}&page=${page}&_id=${body._id}`, headerOptions)
    },
    getGroupDetail: (id) => {
        return axios.get(`${API.getGroupDetail}/${id}`, headerOptions)
    },
    getSuggestionDetail: (id) => {
        return axios.get(`${API.getSuggestionDetail}/${id}`, headerOptions)
    },
    getEventAttendanceStats: (eventId, page = 1, limit = 10, activePage = null) => {
        let url = `${API.getEventAttendanceStats}/${eventId}/stats?page=${page}&limit=${limit}`;
        if (activePage !== null) {
            url += `&activePage=${activePage}`;
        }
        return axios.get(url, headerOptions)
    },
       getAllNetworks: (limit, searchKey, page, is_active, network_type) => {
        let url = `${API.getAllNetworks}?limit=${limit}&search=${searchKey}&page=${page}`;
        if (is_active !== undefined && is_active !== '') url += `&is_active=${is_active}`;
        if (network_type && network_type !== '') url += `&network_type=${network_type}`;
        return axios.get(url, headerOptions)
    },
    getActiveNetworks: () => {
        return axios.get(`${API.getActiveNetworks}`, headerOptions)
    },
    getNetwork: (id) => {
        return axios.get(`${API.getNetwork}/${id}`, headerOptions)
    },
    createNetwork: (body) => {
        return axios.post(`${API.createNetwork}`, body, headerOptions)
    },
    updateNetwork: (id, body) => {
        return axios.put(`${API.updateNetwork}/${id}`, body, headerOptions)
    },
    removeNetwork: (id) => {
        return axios.delete(`${API.removeNetwork}/${id}`, headerOptions)
    },
    getActiveRewardConfig: () => {
        return axios.get(`${API.getActiveRewardConfig}`, headerOptions)
    },
    getRewardConfigHistory: (limit, page) => {
        return axios.get(`${API.getRewardConfigHistory}?limit=${limit}&page=${page}`, headerOptions)
    },
    getAllRewardConfigs: (limit, searchKey, page) => {
        return axios.get(`${API.getAllRewardConfigs}?limit=${limit}&search=${searchKey}&page=${page}`, headerOptions)
    },
    getRewardConfig: (id) => {
        return axios.get(`${API.getRewardConfig}/${id}`, headerOptions)
    },
    createRewardConfig: (body) => {
        return axios.post(`${API.createRewardConfig}`, body, headerOptions)
    },
    updateRewardConfig: (id, body) => {
        return axios.put(`${API.updateRewardConfig}/${id}`, body, headerOptions)
    },
    removeRewardConfig: (id) => {
        return axios.delete(`${API.removeRewardConfig}/${id}`, headerOptions)
    },
    getAllMonthlyPayments: (limit, searchKey, page, year, month, status) => {
        let url = `${API.getAllMonthlyPayments}?limit=${limit}&search=${searchKey}&page=${page}`;
        if (year) url += `&year=${year}`;
        if (month) url += `&month=${month}`;
        if (status) url += `&status=${status}`;
        return axios.get(url, headerOptions)
    },
    getMonthlyPaymentDetail: (id) => {
        return axios.get(`${API.getMonthlyPaymentDetail}/${id}`, headerOptions)
    },
    approveMonthlyPayment: (id) => {
        return axios.put(`${API.approveMonthlyPayment}/${id}/approve`, { _id: id }, headerOptions)
    },
    confirmMonthlyPayment: (id, body = {}) => {
        return axios.put(`${API.confirmMonthlyPayment}/${id}/confirm-payment`, { _id: id, ...body }, headerOptions)
    },
    exportMonthlyPaymentsExcel: (year, month) => {
        return axios.get(`${API.exportMonthlyPaymentsExcel}/${year}/${month}/export`, {
            ...headerOptions,
            responseType: 'blob'
        })
    },
    markAllMonthlyPaymentsAsPaid: (year, month) => {
        return axios.put(`${API.markAllMonthlyPaymentsAsPaid}/${year}/${month}/mark-all-paid`, {}, headerOptions)
    },
    getSlotRewards: (slotId) => {
        return axios.get(`${API.getSlotRewards}/${slotId}/rewards`, headerOptions)
    },
    getRewardAnalysis: (page = 1, limit = 12) => {
        return axios.get(`${API.getRewardAnalysis}?page=${page}&limit=${limit}`, headerOptions)
    },
    // User-facing reward API functions
    getUserWallet: () => {
        return axios.get(`${API.getUserWallet}`, headerOptions)
    },
    updateUserWalletAddress: (body) => {
        return axios.put(`${API.updateUserWalletAddress}`, body, headerOptions)
    },
    getUserMonthlyRecap: (year, month) => {
        return axios.get(`${API.getUserMonthlyRecap}/${year}/${month}`, headerOptions)
    },
    getPassedEventsWithEarnings: (filter = '', page = 1, limit = 10, search = '') => {
        let url = `${API.getPassedEventsWithEarnings}?dated=passed&page=${page}&limit=${limit}`;
        if (filter) url += `&filter=${filter}`;
        if (search) url += `&search=${search}`;
        return axios.get(url, headerOptions)
    },


}

export default apiFunctions;